import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/browser";
import { CLIENT_CONFIG, ClientConfig } from "./config";

declare global {
  interface Window {
    orp: ClientConfig;
  }
}

if (CLIENT_CONFIG.dsn)
  Sentry.init({
    dsn: CLIENT_CONFIG.dsn,
    environment: CLIENT_CONFIG.environment,
  });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
